module.exports = __webpack_public_path__ + "img/264.41364902.png";